import React from 'react';
import { useTicketsContext } from '../../../contexts/pdfTicketsContext';
import { FIREBASE_STORAGE } from '../../../firebase/firebase';
import { getDownloadURL, ref } from 'firebase/storage';
import './pdfViewButton.css';

interface PdfViewButtonProps {
    ticketNumber: string;
    carrierName: string;
    producerName: string;
    disabled?: boolean;
}

const PdfViewButton: React.FC<PdfViewButtonProps> = ({
    ticketNumber,
    carrierName,
    producerName,
    disabled = false,
}) => {
    const { availableTickets } = useTicketsContext();

    // Check if the PDF is available
    const identifier = `${ticketNumber}_${carrierName}`;
    const isAvailable = availableTickets.includes(identifier);

    const handleViewPdf = async () => {
        if (!isAvailable || disabled) return;

        try {
            // Construct the path to the PDF file
            const pdfPath = `tickets/${producerName}/${ticketNumber}_${carrierName}_${producerName}.pdf`;
            const pdfRef = ref(FIREBASE_STORAGE, pdfPath);
            
            // Get the download URL
            const downloadURL = await getDownloadURL(pdfRef);
            
            // Open PDF in a new tab
            window.open(downloadURL, '_blank');
            
        } catch (error) {
            console.error('Error opening PDF:', error);
            alert('Error opening PDF. The file may not exist or you may not have permission to view it.');
        }
    };

    return (
        <button
            className='pdfViewButton-mainContainer'
            onClick={handleViewPdf}
            disabled={isAvailable ? disabled : true}
        >
            View PDF
        </button>
    );
};

export default PdfViewButton;